import { PlayType, PlaylistType } from '@kollective-frontend/ksdk-api';

const stringToPlayType = (value?: PlaylistType): PlayType => {
  switch ((value || '').toLowerCase()) {
    case 'vod':
    case 'static':
      return PlayType.VOD;
    case 'event':
    case 'dynamic':
      return PlayType.LIVE;
    default:
      return PlayType.UNKNOWN;
  }
};

export default stringToPlayType;
